import React from 'react'
import LayoutAdmin from '../../components/layout/LayoutAdmin'

const SATransactions = () => {
  return (
    <LayoutAdmin>
      <h2 className="text-xl font-semibold mb-4">Super Admin - Transactions</h2>
      <div className="bg-white border rounded p-4">This is a dummy Super Admin Transactions page.</div>
    </LayoutAdmin>
  )
}

export default SATransactions


